import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FaGraduationCap } from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin, FiStar, FiActivity, FiUser, FiBook, FiGlobe } = FiIcons;

const Biography = () => {
  return (
    <section id="about" className="py-24 px-4 bg-zinc-950 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-green-900/5 to-transparent"></div>
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-6xl font-black mb-4 uppercase leading-none">
            Nuestra <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 via-yellow-500 to-green-600">Misión Educativa</span>
          </h2>
          <p className="max-w-2xl mx-auto text-gray-400">
            Cerrando brechas culturales y construyendo carreras globales a través del dominio del inglés.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-8 text-lg text-gray-300 leading-relaxed font-light">
            <div className="bg-zinc-900/80 p-8 rounded-2xl border-l-4 border-yellow-500 shadow-xl">
              <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2 uppercase tracking-tighter">
                <SafeIcon icon={FaGraduationCap} className="text-yellow-500" /> Por Qué Existimos
              </h3>
              <p className="mb-4">
                En <strong>OnlineClassesEnglish.com</strong>, creemos que el idioma es la llave definitiva hacia la oportunidad. Ya sea para conseguir el trabajo de tus sueños, aprobar un examen migratorio o simplemente viajar por el mundo, la fluidez en inglés abre puertas.
              </p>
            </div>

            <div className="bg-zinc-900/80 p-8 rounded-2xl border-l-4 border-red-500 shadow-xl">
              <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-2 uppercase tracking-tighter">
                <SafeIcon icon={FiBook} className="text-red-500" /> Metodología Gamificada
              </h3>
              <p className="mb-4">
                Nuestra metodología <strong>"Immersión & Interacción"</strong> se enfoca en el uso del mundo real. Priorizamos la confianza al hablar, la neutralización de acento y la etiqueta de negocios sobre la memorización monótona de reglas gramaticales.
              </p>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-black border border-zinc-800 rounded-3xl p-8">
              <h3 className="text-2xl font-black text-white mb-6 uppercase italic">Pilares Educativos</h3>
              <div className="space-y-6">
                <div>
                  <h4 className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-2">Estilo de Enseñanza</h4>
                  <p className="text-white">Comunicativo • Interactivo • Práctico • Centrado en el Estudiante</p>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-2">Certificaciones</h4>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-zinc-800 px-3 py-1 rounded-full text-xs text-yellow-500">TEFL Certified</span>
                    <span className="bg-zinc-800 px-3 py-1 rounded-full text-xs text-green-500">TESOL Masters</span>
                    <span className="bg-zinc-800 px-3 py-1 rounded-full text-xs text-blue-500">IELTS Experts</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-yellow-900/20 to-black border border-yellow-700/30 rounded-3xl p-8 relative overflow-hidden">
              <div className="absolute top-0 right-0 p-4 opacity-10">
                <SafeIcon icon={FiActivity} className="text-9xl text-yellow-500" />
              </div>
              <h3 className="text-2xl font-black text-white mb-6 relative z-10 uppercase italic">Diferenciador</h3>
              <ul className="space-y-4 relative z-10">
                <li className="flex items-start gap-3">
                  <SafeIcon icon={FiUser} className="text-blue-500 mt-1" />
                  <div>
                    <strong className="block text-white">Personalizado</strong>
                    <span className="text-sm text-gray-400">Cada estudiante privado recibe un currículum adaptado a sus objetivos.</span>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <SafeIcon icon={FiStar} className="text-red-500 mt-1" />
                  <div>
                    <strong className="block text-white">Calidad Premium</strong>
                    <span className="text-sm text-gray-400">Cursos en HD y maestros nativos de alto nivel.</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Biography;